import { ExternalLink } from 'lucide-react'

/**
 * HN / ชื่อในระบบ → the patient's TREATMENT page, in a new tab.
 *
 * One component because the codebase already carries three divergent local copies of this
 * idea — Huddle.jsx:470 (a <button> + window.open), Treatments.jsx:942 (an anchor),
 * OutstandingDrawer.jsx:132 (a different anchor) — and this change adds six more call sites.
 *
 * ⚠️ A REAL <a>, NOT window.open. ⌘-click, middle-click, "copy link address", and keyboard
 *    Tab/Enter all come free from an anchor and none of them come from window.open.
 * ⚠️ `/treatments`, NOT `/patient/:id`. App.jsx:249 sends the bare index route to `info`,
 *    so every existing report link in the app lands on the wrong tab.
 * ⚠️ THE GUARD IS `Number(pid) > 0`, NOT `!= null`. claim_import_row stores the NUMBER 0
 *    on an unmatched row (_stage.js, claimMatch.js), so a null check would happily ship
 *    /patient/0/treatments. When there is no patient, render the text unwrapped.
 * ⚠️ STAYS `inline`, never inline-flex — these cells sit inside `truncate` <td>s in a
 *    table-fixed layout (Reimbursement.jsx:972) and text-overflow does not apply to flex
 *    items. `icon` is opt-in, for the tables whose columns are not fixed width.
 * ⚠️ `onOpen` FIRES BEFORE THE BROWSER NAVIGATES, and any call site whose row marks a
 *    "last viewed" state MUST pass it: stopPropagation kills the row onClick that would
 *    otherwise have done the marking.
 * ⚠️ `draggable={false}` — HN and names get click-dragged to copy into the ปกส. portal,
 *    and an anchor drags as a link by default, which breaks the selection.
 */
// `hoverClass` replaces the default hover treatment — pass '' when the children style
// their own hover through `group-hover:` (the anchor always carries `group`).
export default function PatientLink({ patientId, onOpen, className = '', hoverClass = 'hover:text-brand-600 hover:underline', icon = false, children }) {
  const pid = Number(patientId) > 0 ? Number(patientId) : 0
  if (!pid) return <>{children}</>
  return (
    <a
      href={`/patient/${pid}/treatments`}
      target="_blank"
      rel="noopener noreferrer"
      draggable={false}
      onClick={(e) => { e.stopPropagation(); onOpen?.() }}
      title="เปิดหน้าการรักษาของคนไข้ในแท็บใหม่"
      className={`group underline-offset-2 transition-colors ${hoverClass} ${className}`}
    >
      {children}
      {icon ? <ExternalLink size={11} className="inline ml-0.5 align-baseline text-slate-400" /> : null}
    </a>
  )
}
